import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import renderSelectForField from '../helpers/renderSelectForField';
import { unitOptions } from '../../enums/units';

class FoodUnitsField extends Component {
  render() {
    const { fieldName = 'preferred_food_units', label = 'Food Units', inputCaption } = this.props;
    return (
      <Field
        name={fieldName}
        label={label}
        component={renderSelectForField}
        stackedlabel
        {...{
          itemProps: {},
          inputProps: {
            options: unitOptions,
            isClearable: false,
          },
        }}
      />
    );
  }
}

FoodUnitsField.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  inputCaption: PropTypes.string,
};

export default FoodUnitsField;
